import { useLayoutEffect, useState } from 'react';
import { Fade, IconButton, Portal } from '@mui/material';
import ChevronLeftIcon  from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { ThemeContext } from '@emotion/react';
import { useTheme } from '@mui/material/styles';
import React from 'react';

type Side = 'left' | 'right';
interface Props {
  side: Side;
  disabled?: boolean;
  onClick: () => void;
  paperRef: React.RefObject<HTMLDivElement>;
}

function NavButton({
  side, disabled, onClick, top, x,
}: {
  side: 'left' | 'right'
  disabled?: boolean
  onClick?: () => void
  top: number
  x: number
}) {

  const theme = useTheme()
  if (!onClick) return null;
  return (
    <IconButton
      onClick={onClick}
      disabled={disabled}
      sx={{
        position : 'fixed',
        top,
        width    : 72,
        height   : 72,
        left     : side === 'left'  ? x : undefined,
        right    : side === 'right' ? x : undefined,
        transform: 'translateY(-50%)',

        zIndex   : theme.zIndex.modal + 1,
      }}
    >
      {side === 'left' ? <ChevronLeftIcon sx={{fontSize: "4rem", color:"white"}} /> : <ChevronRightIcon sx={{fontSize: "4rem", color:"white"}} />}
    </IconButton>
  )
}
export default  NavButton